import { useState } from "react";
import { Menu, MenuItem } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import "./HomeMenu.css";
import "../../css/Icons.css";

const HOME_MENU = {
  DELETE: "delete",
  RENAME: "rename",
  TAGS: "tags",
  COPY: "copy",
};

type HomeMenuProps = {
    formId: string;
    onDelete: (formId: string) => void;
    onRename: (formId: string) => void;
    onCopy: (formId: string) => void;
    onUpdateTags: (formId: string) => void;
};

export default function HomeMenu({ 
    formId,
    onDelete,
    onRename,
    onCopy,
    onUpdateTags
} : HomeMenuProps) {
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();

  const handleButtonClick = (event: any) => {
    setAnchorEl(event.currentTarget);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleMenuClose = (e: any) => {
    e.stopPropagation();
    setAnchorEl(null);
  };

  const handleMenuSelection = (selection: string) => {
    // close the menu
    setAnchorEl(null);

    // route it
    switch (selection) {
      case HOME_MENU.DELETE:
        onDelete(formId);
        break;
      case HOME_MENU.RENAME:
        onRename(formId);
        break;
      case HOME_MENU.TAGS:
        onUpdateTags(formId);
        break;
      case HOME_MENU.COPY:
        onCopy(formId);
        break;
      default:
    }
  };

  
  return (
    <>
      <div className="home-menu" onClick={handleButtonClick}>
        <div className="home-menu-image">
          <img className="icon-three-dots-vertical" alt="" />
        </div>
      </div>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}>
        <MenuItem 
            onClick={(e: any) => {
                e.stopPropagation();
                handleMenuSelection(HOME_MENU.TAGS)
            }}
        >
          Edit Tags
        </MenuItem>

        <MenuItem 
             onClick={(e: any) => {
                e.stopPropagation();
                handleMenuSelection(HOME_MENU.RENAME)
            }}
        >
          Rename
        </MenuItem>

        <MenuItem 
             onClick={(e: any) => {
                e.stopPropagation();
                handleMenuSelection(HOME_MENU.DELETE)
            }}
        >
          Delete
        </MenuItem>

        <MenuItem 
             onClick={(e: any) => {
                e.stopPropagation();
                handleMenuSelection(HOME_MENU.COPY)
            }}
        >
          Copy
        </MenuItem>
      </Menu>
    </>
  );
}
